import { v4Date, v4Number } from "./v4Explanation";

export const isV4Expired = suggestion =>
  suggestion?.stale === true ||
  Date.parse(suggestion?.expires_at) <= Date.now();

export function v4ReferenceState(suggestion, requestStatus) {
  const price = v4Number(suggestion?.suggested_anchor_base_brl);
  const hasPrice =
    suggestion?.status === "ready" && price !== null && price > 0;
  const expired = isV4Expired(suggestion);
  const attempt = suggestion?.latest_attempt;
  const updating =
    requestStatus === "loading" || attempt?.cycle_status === "running";
  const failed =
    requestStatus === "error" ||
    (suggestion?.reference_retained === true &&
      !updating &&
      (["error", "rejected", "insufficient_data"].includes(attempt?.status) ||
        ["error", "interrupted"].includes(attempt?.cycle_status) ||
        Boolean(attempt?.failure_code)));
  const date = v4Date(suggestion?.generated_at);
  const secondary = !hasPrice
    ? null
    : updating
    ? "Atualizando…"
    : failed
    ? "Última sugestão · atualização falhou"
    : expired || suggestion?.reference_retained
    ? `Última sugestão · ${date}`
    : null;
  return { hasPrice, expired, updating, failed, secondary, date };
}
